var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpressVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 8,
    fill: "#EDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.40224C4.5 8.21134 4.5 7.6159 4.73176 7.16103C4.93563 6.76093 5.26093 6.43563 5.66103 6.23176C6.1159 6 6.71134 6 7.90224 6H10.6666C11.8575 6 12.4529 6 12.9078 6.23176C13.3079 6.43563 13.6332 6.76093 13.837 7.16103C14.0688 7.6159 14.0688 8.21134 14.0688 9.40224V11.1034C14.0688 12.2943 14.0688 12.8897 13.837 13.3446C13.6332 13.7447 13.3079 14.07 12.9078 14.2738C12.4529 14.5056 11.8575 14.5056 10.6666 14.5056H7.90224C6.71134 14.5056 6.1159 14.5056 5.66103 14.2738C5.26093 14.07 4.93563 13.7447 4.73176 13.3446C4.5 12.8897 4.5 12.2943 4.5 11.1034V9.40224Z",
    fill: "url(#paint0_linear_2949_132511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.132 8.91392C15.132 8.82089 15.132 8.77437 15.1459 8.73307C15.1582 8.69654 15.1783 8.66312 15.2048 8.63514C15.2348 8.6035 15.2759 8.58172 15.3581 8.53815L16.5411 7.91116C16.9532 7.69276 17.1593 7.58356 17.3274 7.60555C17.4741 7.62474 17.6062 7.70423 17.6918 7.82488C17.79 7.96312 17.79 8.19631 17.79 8.66269V11.8429C17.79 12.3093 17.79 12.5425 17.6918 12.6807C17.6062 12.8014 17.4741 12.8809 17.3274 12.9001C17.1593 12.922 16.9532 12.8128 16.5411 12.5944L15.3581 11.9674C15.2759 11.9239 15.2348 11.9021 15.2048 11.8705C15.1783 11.8425 15.1582 11.8091 15.1459 11.7725C15.132 11.7312 15.132 11.6847 15.132 11.5917V8.91392Z",
    fill: "url(#paint1_linear_2949_132511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2949_132511",
    x1: 11.145,
    y1: 6,
    x2: 11.145,
    y2: 14.5056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2949_132511",
    x1: 11.145,
    y1: 6,
    x2: 11.145,
    y2: 14.5056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressVideo);
export default __webpack_public_path__ + "static/media/express_video.c862db710332bd50a2aedcb81c97b458.svg";
export { ForwardRef as ReactComponent };